import React from 'react';

import classes from './FilterBox.module.scss';

const FilterBox = ({ children, subTitle, type = 'subtitle' }) => {
  return (
    <div className={classes['filter-box']}>
      {subTitle && <span className={`${classes.subtitle} ${type === 'subtitle' ? 'semibold-16' : 'bold-18'}`}>{subTitle}</span>}
      {children && <div className={classes.content}>{children}</div>}
    </div>
  );
};

export default FilterBox;
